import React, { useRef, useState, useEffect, useLayoutEffect} from "react"
import './landing.css';
import {  Link, useHistory} from "react-router-dom";

import { firestore } from "./firebase/firebase";

import SignInModal from './signin';
import SignUpModal from './signup';

import PlansButton from "./paymentLanding";

import { IconButton, AppBar, Toolbar, Button, Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Card, CardContent, Box} from "@mui/material";

import { makeStyles } from '@material-ui/core/styles';
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import cloud from "./cloud.svg"
import logo from "./logo.png"
import { Avatar } from '@material-ui/core';

import imageOne from "./imageOne.svg"
import imageTwo from "./imageTwo.svg"

import Crowd from "./Crowd.mp4"

import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import { useAuth } from "./firebase/AuthContext";

import Password from "./forgotPassword";

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      margin: '5%',
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: '16px',
    padding: theme.spacing(4),
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: theme.spacing(1),
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
  container: {
    backgroundColor: "#F9FAFB",
    padding: "8%",
  },
  image: {
    width: "100%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: "35px",
    fontWeight: "bold",
  },
  subtitle: {
    fontFamily: "Inter",
    color: "#6B7280",
    fontSize: "18px",
  },
  
}));


const LandingPage = () => {
  
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);
  const emailRef2 = useRef();
  const passwordRef2 = useRef();
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const { currentUser, signup, login } = useAuth();
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [stripeId, setStripeId] = useState("");

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});


  useEffect(() => {
    if (currentUser && currentUser.uid) { // add a null check before accessing uid
      const unsubscribe = firestore
        .collection("customers")
        .doc(currentUser.uid)
        .onSnapshot((doc) => {
          const data = doc.data();
          setStripeId(data?.stripeId || ""); // set stripeId state
        });
  
      return unsubscribe; // cleanup the listener
    }
  }, [currentUser]);

  
    const handleOpen = () => {
      if(!currentUser){
        setOpen(true);
      }else{
        history.push("/workspace")
      }
    };

    const handleOpenTwo = () => {
      if(!currentUser){
        setOpenTwo(true);
      }else{
        
        const handleCustomerPortalClick = async () => {
          setIsLoading(true);
        
          try {
            const response = await fetch(`${process.env.REACT_APP_PORTAL}/create-portal-link`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                returnUrl: window.location.origin,
                locale: 'auto',
                userId: `${stripeId}`
              }),
            });
        
            const { url } = await response.json();
            window.location.assign(url);
          } catch (error) {
            console.error(error);
          } finally {
            setIsLoading(false);
          }
        };

        handleCustomerPortalClick();

      }
      
    };


    const handleOpenThree = () => {
      if(!currentUser){
        setOpenTwo(true);
      }else{
        history.push("/workspace")
      }
    };




    const SignInButtonModalTwo = () => {

      const handleClose = () => {
        setOpenTwo(false);
      };
    
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          setError("");
          setLoading(true);
          await login(emailRef2.current.value, passwordRef2.current.value);
          history.push("/workspace")
          handleClose();
        } catch {
          setError("Incorrect email or password.");
        }
    
        setLoading(false);
      };
      
      
      return (
        <div>
        <Modal
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', outline:'none' }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openTwo}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={openTwo}>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%', outline:'none' }}>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
                <center>
                  <h2 style={{ fontFamily: "Inter", fontSize: "30px", fontWeight: "bold" }}>Sign In</h2>
                  <h5 style={{ color: "red" }}>{error}</h5>
                  <form style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onSubmit={handleSubmit}>
                    <TextField
                      id="email"
                      label="Email"
                      inputRef={emailRef2}
                      required
                      sx={{
                        "& fieldset": {
                          border: "none",
                        },
                      }}
                      InputProps={{
                        style: {
                          width: "100%",
                          fontFamily: "'inter",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          color: `grey`,
                          margin: "20px",
                          textAlign: "center",
                          "&::placeholder": {
                            textAlign: "center",
                          },
                        },
                      }}
                    />
                    <TextField
                      inputRef={passwordRef2}
                      required
                      id="Password"
                      label="Password"
                      type="password"
                      sx={{
                        "& fieldset": {
                          border: "none",
                        },
                      }}
                      InputProps={{
                        style: {
                          width: "100%",
                          fontFamily: "'inter",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          color: `grey`,
                          margin: "20px",
                          textAlign: "center",
                          "&::placeholder": {
                            textAlign: "center",
                          },
                        },
                      }}
                    />
                    <Button
                      style={{ backgroundColor: "#7E3AF2", color: "white", fontFamily: "Inter", marginBottom: "10px" }}
                      disabled={loading}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </form>
                  <div style={{ paddingTop: "60px" }}>
                    <Password />
                  </div>
                  <h4 style={{ color: "#7E3AF2", fontFamily: "Inter", margin: "30px", cursor: "pointer" }} onClick={() => { handleClose(); handleOpen(); setError(null);  }}>
                    Need an account?
                  </h4>
                </center>
              </div>
            </Fade>
          </Modal>
        </div>
      );
      
        
      
      };
  
    

  const SignInButtonModal = () => {

  const handleClose = () => {
    setOpen(false);
  };


    async function handleSubmit(e) {
      e.preventDefault()
  
      if (passwordRef.current.value !== passwordConfirmRef.current.value) {

        return setError("Passwords do not match")
        
      } else {

        try {
          setError("")
          setLoading(true)
          await signup(emailRef.current.value, passwordRef.current.value);
          history.push("/workspace")
          handleClose();
        } catch {
            signup(emailRef.current.value, passwordRef.current.value).catch(error => {
              switch (error.code) {
                 case 'auth/email-already-in-use':
                  setError(`Email address already in use.`);
                   break;
                 case 'auth/invalid-email':
                  setError(`Email address is invalid.`);
                   break;
                 case 'auth/operation-not-allowed':
                  setError(`Error during sign up.`);
                   break;
                 case 'auth/weak-password':
                  setError('Password is not strong enough. Add additional characters including special characters and numbers.');
                   break;
                 default:
                  setError(error.message);
                   break;
               }
           });
        }

      }
  
      setLoading(false)
    };
  
  
    return (
      <div>
        <Modal
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={open}>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%' }}>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
              <center>
                <h2 style={{ fontFamily: 'Inter', fontSize: "30px", fontWeight: 'bold' }}>Sign Up</h2>
                <h5 style={{ color: "red" }}>{error}</h5>
                <form onSubmit={handleSubmit} style={{ textAlign: "center" }}>
                  <TextField
                    inputRef={emailRef}
                    required
                    label="Email"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <TextField
                    inputRef={passwordRef}
                    required
                    label="Password"
                    type="password"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <TextField
                    inputRef={passwordConfirmRef}
                    required
                    label="Password Confirmation"
                    type="password"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <Button style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', margin: '30px' }} type="submit">
                    Submit
                  </Button>
                </form>
                <p>Please note, by signing up you are agreeing to our terms and condiction.</p>
                <h4 style={{ color: '#7E3AF2', fontFamily: 'Inter', margin: '30px', cursor: 'pointer' }} onClick={() => { handleClose(); handleOpenTwo(); setError(null); }}>
                  Have an account?
                </h4>
              </center>
            </div>
          </Fade>
        </Modal>
      </div>
    );
    
    
    
    
  
  };
  
  return (
    <>
    
      <div >
      <AppBar position="static" style={{ backgroundColor: 'white', boxShadow: "none" }}>
  <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
    <Link to='/'><img src={logo} alt="logo" style={{ width: '150px' }} /></Link>
    <div style={{ display: 'flex', gap: '20px' }}>
    <Link style={{textDecoration: 'none'}} to="/blog">
  <Button style={{ backgroundColor: 'transparent', textDecoration: 'none', color: 'black', border: 'none', outline: 'none', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
    Blog
  </Button>
</Link>
      <Button onClick={() => handleOpenThree()} style={{ backgroundColor: 'transparent', textDecoration: 'none', color: 'black', border: 'none', outline: 'none', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
  Sign In
</Button>
      <Button onClick={() => handleOpen()} style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
        Sign Up
      </Button>
    </div>
  </Toolbar>
</AppBar>


        {SignInButtonModal()}
        {SignInButtonModalTwo()}
        <div style={{ marginLeft: '10%', marginRight: '10%', marginBottom: '4%', marginTop:'7%' }} data-aos="fade-up" data-aos-duration="3000">
  {/*Header */}
  <Grid container spacing={6}>
    <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', mt: { xs: '5rem', md: 0 } }}>
      <Typography variant="h4" component="h1" sx={{ fontFamily: 'Inter', fontWeight: 'bold', mb: 2, fontSize: '3rem', lineHeight: 1.2}}>
      Struggling to communicate your thoughts?
      </Typography>
      <Typography variant="body1" sx={{ fontFamily: 'Inter', color: '#6B7280', fontSize: '1rem', lineHeight: 1.5, mb: 4 }}>
        Use our AI assisted thought management framework to help you communicate your ideas or feelings.
      </Typography>
      <button onClick={()=>handleOpen()} style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Start a board</button>
    </Grid>
    <Grid item md={6} sx={{ textAlign: 'center', display: { xs: 'none', md: 'block' } }}>
      <img src={cloud} alt="Landing" style={{ width: '100%', maxWidth: '600px', height: 'auto', }} />
    </Grid>
  </Grid>
</div>

            
            {/*Video */}

            <div style={{ marginTop: '5%', marginBottom:'5%', padding: '2%' }} data-aos="fade-up" data-aos-duration="3000">
  <center>
    <Typography variant="h3" sx={{ fontFamily: "Inter", fontSize: "35px", fontWeight: "bold" }}>
      Overview
    </Typography>
    <Typography variant="h5" sx={{ paddingTop: '10px', paddingBottom:'10px', fontFamily: "Inter", color: "#6B7280", fontSize: "18px"}}>
      Learn about the power of the tracker.
    </Typography>
    <video style={{ borderRadius: '10px', maxWidth: '100%' }} width="640" height="360" controls>
      <source src={Crowd} type="video/mp4" />
    </video>
  </center>
</div>


<div  data-aos="fade-up" data-aos-duration="3000">
          {/*Process 1 */}
          <Box sx={{ backgroundColor: "#F9FAFB", padding: {xs: "4%", md: "8%"}, overflow: "hidden" }}>
  <Grid container spacing={2}>
  <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", paddingRight: {xs: 0, md: '10%'} }}>
      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Typography variant="h3" sx={{ fontFamily: "Inter", fontSize: {xs: "28px", sm: "35px"}, fontWeight: "bold", mb: { xs: 1, sm: 0 } }}>
          Build simple to understand thought processes.
        </Typography>
        <Typography variant="h5" sx={{ paddingTop: {xs: '20px', sm: '30px'}, fontFamily: "Inter", color: "#6B7280", fontSize: {xs: "16px", sm: "18px"}, mt: { xs: 2, sm: 0 }, mb: {xs: 2, sm: 0} }}>
          Plan your thoughts and any offshoots from an idea in an easy-to-read flow chart.
        </Typography>
      </Box>
    </Grid>
    <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", marginTop: {xs: "20px", sm: 0} }}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <img src={imageOne} alt="Landing" sx={{ width: {xs: "70%", sm: "100%"} }} />
      </Box>
    </Grid>
  </Grid>
  <style>
    {`@media (max-width: 960px) {
      div[data-aos="fade-up"] > div {
        flex-direction: column-reverse;
      }
      div[data-aos="fade-up"] > div > div:first-of-type {
        margin-bottom: 2rem;
      }
    }`}
  </style>
</Box>
<div></div>

    {/*Process 2 */}
    <div>
  <Box sx={{ backgroundColor: "#F9FAFB", padding: "8%", overflow: "hidden" }}>
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Typography variant="h3" sx={{ fontFamily: "Inter", fontSize: {xs: "28px", sm: "35px"}, fontWeight: "bold", mb: { xs: 1, sm: 0 } }}>
            Stuck for a thought? - Ask for suggestions.
          </Typography>
          <Typography variant="h5" sx={{ paddingTop:'30px', fontFamily: "Inter", color: "#6B7280", fontSize: "18px", mt: { xs: 2, sm: 0 } }}>
            Using the latest AI, we’re able to suggest topics, actions or insights around your ideas with a click of the button.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", paddingTop: { xs: "8%", sm: 0 } }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 4, sm: 0 } }}>
          <img src={imageTwo} alt="Landing" sx={{ width: "100%" }} />
        </Box>
      </Grid>
    </Grid>
    <style>
    {`@media (max-width: 960px) {
      div[data-aos="fade-up"] > div {
        flex-direction: column-reverse;
      }
      div[data-aos="fade-up"] > div > div:first-of-type {
        margin-bottom: 2rem;
      }
    }`}
    </style>
  </Box>
</div>
</div>
            {/*quote 1 */}
            <div style={{ margin: '4% 10% 0' }} data-aos="fade-up" data-aos-duration="3000">
  <div style={{ margin: '10%' }}>
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <FormatQuoteIcon style={{ fontSize: '2.5rem', color: '#6B7280' }} />
      <h5 style={{ fontFamily: 'Inter', color: 'black', fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', margin: '1rem 0' }}>
        "Being neurodivergent in the workplace can be tough. It’s hard to explain your thoughts and how you arrived at a particular idea. This app has been a life saver for communicating!"
      </h5>
      <Avatar  />
      <h6 style={{ fontFamily: 'Inter', color: '#6B7280', fontSize: '0.8rem' }}>Tom Morris</h6>
    </div>
  </div>
</div>

          {/*Price 1 */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#F9FAFB', padding: '5%' }} data-aos="fade-up" data-aos-duration="3000">
            <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontFamily: 'Inter', fontSize: '36px', fontWeight: 'bold' }}>Pricing</h2>
      <h5 style={{ fontFamily: 'Inter', color: '#6B7280', fontSize: '18px' }}>Whether you’re here to plan or here for full features we’ve got you covered.</h5>
          <Grid container spacing={2} justify="center">
      <Grid item xs={12} md={6}>
        <Card style={{ maxWidth: '400px', backgroundColor: '#FFFFFF', boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)', borderRadius: '8px', padding: '32px' }}>
          <CardContent>
          <h4 style={{ fontFamily: 'Inter', fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>Starter</h4>
                  <h5 style={{fontFamily: 'Inter', color: '#6B7280', fontSize: '15px' }}>Get access to our tool and track your thoughts.</h5>
                  <h3 style={{ fontFamily: 'Inter', fontSize: '36px', fontWeight: 'bold', marginBottom: '16px' }}>$0<span style={{ fontFamily: 'Inter', fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color:'grey'}}>/month</span></h3>
                  <ul style={{ textAlign: 'left', marginBottom: '24px', listStyleType: 'none' }}>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Unlimited mapping</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Save your maps</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>No setup, monthly, or hidden fees</li>
        <li style={{padding: '6px'}}><span><CloseIcon style={{color: 'red', paddingRight: '3%'}}/></span>1000 x AI generated suggestions</li>
        <li style={{padding: '6px'}}><span><CloseIcon style={{color: 'red', paddingRight: '3%'}}/></span>250 x AI generated summaries</li>
      </ul>
      <button onClick={()=>handleOpen()} style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Get started</button>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card style={{ maxWidth: '400px', backgroundColor: '#FFFFFF', boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)', borderRadius: '8px', padding: '32px' }}>
          <CardContent>
          <h4 style={{ fontFamily: 'Inter', fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>Standard</h4>
      <h5 style={{fontFamily: 'Inter', color: '#6B7280', fontSize: '15px' }}>Get full access.</h5>
      <h3 style={{ fontFamily: 'Inter', fontSize: '36px', fontWeight: 'bold', marginBottom: '16px' }}>$20<span style={{ fontFamily: 'Inter', fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color:'grey'}}>/month</span></h3>
      <ul style={{ textAlign: 'left', marginBottom: '24px', listStyleType: 'none' }}>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Unlimited mapping</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Save your maps</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>Secure Stripe intergration</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>1000 x AI generated suggestions</li>
        <li style={{padding: '6px'}}><span><DoneIcon style={{color: 'green', paddingRight: '3%'}}/></span>250 x AI generated summaries</li>
      </ul>
      {!currentUser ? (<button onClick={() => handleOpenTwo()} style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', margin: '20px',padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Select Plan</button>):(<PlansButton/>)}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
    
    </div>

    </div>
      <div style={{ backgroundColor: 'white', width: '100%' }}>
{/* accordian*/}
<div style={{ margin: '50px' }}  data-aos="fade-up" data-aos-duration="3000">

      <Typography variant="h4" align="center" gutterBottom  style={{ fontFamily: 'Inter', fontSize: '36px', fontWeight: 'bold', paddingBottom: '15px' }}>
        Frequently Asked Questions
      </Typography>

      <Accordion defaultExpanded={true} align="left">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" style={{fontFamily: 'Inter', fontSize: "21px", fontWeight: 'bold'}}>How many thoughts can i keep stored?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
          We don’t cap how many boards or thoughts you can have. Thoughts are limitless and so should being able to document them.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded={false}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" style={{fontFamily: 'Inter', fontSize: "21px", fontWeight: 'bold'}}>How does the AI work?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
          We use the latest AI models, in particular OpenAI’s ChatGPT. The model has been trained to take information in, learn and develop. Similar to a babies brain to a toddlers to an adults.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded={false}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" style={{fontFamily: 'Inter', fontSize: "21px", fontWeight: 'bold'}}>How does this help me communicate?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
          We take in all your finalized inputs and summaries them in a short and concise paragraph so you can structure how you intend to talk about them better.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded={false}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" style={{fontFamily: 'Inter', fontSize: "21px", fontWeight: 'bold'}}>WIll the AI do the thinking for me?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
          We don’t intend to do your work for you but we are here to assist. Helping you when you have writers block or needing some direction.
          </Typography>
        </AccordionDetails>
      </Accordion>

{/* CTA*/}
<div style={{ marginTop: '100px',marginBottom: '100px', backgroundColor: 'white' }}  data-aos="fade-up" data-aos-duration="3000">

<div style={{ display: "flex", flexDirection: "row", textAlign: 'center'}}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignContent: 'left' }}>
        <h3 style={{fontFamily: 'Inter', fontSize: "35px", fontWeight: 'bold'}}>Start free today</h3>
        <h5 style={{fontFamily: 'Inter', color: '#6B7280'}}>Get started mapping out your thoughts and see the benefits.</h5>
        <button onClick={()=>handleOpen()} style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Start a board</button>
      </div>
    </div>

    </div>
</div>
</div>
          <div >
          <center>
          <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 1 }}>
          <img src={logo} alt="logo" style={{ maxWidth: '15%', minWidth: '15%', padding: '10px' }} />
          </div>
         
            </div>
             
          <h4 ><Link style={{textDecoration: 'none', color: 'black'}} to="/blog">Blog</Link></h4>
          <h4 ><Link style={{textDecoration: 'none', color: 'black'}} to="/terms">Terms and Condictions</Link></h4>
          <h4 ><Link style={{textDecoration: 'none', color: 'black'}} to="/privacy">Privacy</Link></h4>
          <h4 ><Link style={{textDecoration: 'none', color: 'black'}} to="/contact">Contact</Link></h4>

            <p style={{fontSize:'10px'}}>Copyright ® 2023 All rights Reserved.</p>
          </center>
          </div>
      </div>
      </>
    );
}

export default LandingPage;
